<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-05 10:12:06
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-22 14:41:44
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\components\product.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class='product-item' :style="{ background: checked ? '#FFF4F4' : '#f7f8fa' }">
        <div class="product-info">
            <img class="logo" :src="logo" alt="">
            <div class="product-name">{{ name }}</div>
            <van-checkbox v-show="isRegistered" v-model="checked" checked-color="#d32537"></van-checkbox>
        </div>
        <div class="sn-box" v-show="checked">
            <van-field v-if="identifying != 'XFS'" v-model="sn" :placeholder="placeholder" :border="true"
                :clearable="true" error @blur="blur">
                <template #right-icon v-if="isWx">
                    <van-icon v-if="isWx" name="scan" color="#d32537" size="30px" @click="scanCodeClick" />
                    <!-- <van-uploader v-else :after-read="getBarCcode">
                        <van-icon name="scan" color="#d32537" size="30px" />
                    </van-uploader> -->
                </template>
            </van-field>
            <div class="agreement" v-else>
                <van-checkbox v-model="checked" checked-color="#d32537" icon-size="15"></van-checkbox>
                <span @click="goAgreement">特约商户支付服务合作协议</span>
            </div>
        </div>
    </div>
</template>

<script>
import { h5upload } from "@/api/index"
import { compressorImage } from "@/utils/core.js"
import Quagga from '@/utils/quagga.min.js';
import wx from 'weixin-js-sdk'
import { Toast } from 'vant';

export default {
    name: 'ProductItem',
    props: {
        // 是否选中  1 选中 | 0 未选中
        value: {
            type: Number,
            default: 1
        },
        // 产品logo
        logo: {
            type: String,
            default: ''
        },
        // 产品名称
        name: {
            type: String,
            default: '如意刷'
        },
        // 是否已经注册过该产品 false： 未注册， true： 已注册
        isRegistered: {
            type: Boolean,
            default: false
        },
        // 产品标识
        identifying: {
            type: String,
            default: ''
        },
        // 产品sn号
        snCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            sn: "",
            checked: false,
            isWx: false,
        };
    },
    watch: {
        value(val) {
            this.checked = val == 1 ? true : false;
        },
        checked(val) {
            this.$emit('changeSelect', { identifying: this.identifying, status: val ? 1 : 0 })
        },
        snCode(code) {
            this.sn = code
        }

    },
    computed: {
        placeholder() {
            return `请扫码或输入${this.name}终端号`
        },

    },
    mounted() {
        if (this.value) {
            this.checked = true;
        }
    },
    created() {
        this.sn = this.snCode

        var wx = window.navigator.userAgent.toLowerCase();
        if (wx.match(/MicroMessenger/i) == 'micromessenger' || wx.match(/Alipay/i) == "alipay") {
            this.isWx = true // 是微信端
        } else {
            // console.log('不是微信浏览器绘制原生。');
            this.isWx = false
        }
    },
    methods: {
        scanCodeClick() {
            let _ = this
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                desc: 'scanQRCode desc',
                scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                    const code = res.resultStr.split(",")[1]
                    _.$emit("getBarCcode", { identifying: _.identifying, code: code })
                },
                fail: function (res) {
                    Toast("识别失败,请手动输入机具编码")
                },
                template: function (res) { }
            });
        },

        clickCheckbox(val) {
            return false
        },
        changeSelect() {
            this.$emit('changeSelect', { status: !this.isRegistered, type: this.identifying })
        },
        blur() {
            this.$emit('onBlur', { sn: this.sn, type: this.identifying })
        },
        goAgreement() {
            // this.$router.push({ path: '/XFSagreement' })
            this.$emit("showAgreement")
        },

        // 扫码识别
        getCode(val) {
            this.$emit("getBarCcode", { identifying: this.identifying, code: val.code })
        },


        // 识别
        async upload(file) {
            // 压缩 
            const fileData = await compressorImage(file.file, "file", 0.5)

            let formData = new FormData();
            formData.append("file", fileData);
            h5upload(formData).then(res => {
                if (res.code != 200) {
                    Toast.clear()
                    this.$toast("上传失败")
                    return
                }
            })
        },
        //  
        decodeBarcode(dataUrl) {
            const html5QrCode = new Html5Qrcode("reader");
            html5QrCode.scanFile(dataUrl, true).then(decodedText => {
                console.log("result.codeResult.code", decodedText);
                // this.$emit("getBarCcode", { identifying: this.identifying, code: result.codeResult.code })
            }).catch(err => {
                Toast("识别失败，请重新上传图片或手动输入！")
                // this.$emit("getBarCcode", { identifying: this.identifying, code: "" })
            });
        },

        getBarCcode(file) {
            this.deBarCode(file.content)
        },

        deBarCode(src, size = 1200) {
            var config = {
                inputStream: {
                    name: "ImageStream",
                    singleChannel: "true",
                    size: size,
                    singleChannel: false
                },
                locator: {
                    patchSize: 'medium',
                    halfSample: true,
                    debug: true
                },
                numOfWorkers: 0,
                decoder: {
                    readers: ['code_128_reader', 'ean_reader', 'ean_8_reader', 'code_39_reader', 'code_39_vin_reader', 'codabar_reader', 'upc_reader', 'upc_e_reader', 'i2of5_reader']
                },
                locate: true,
                src: src
            }

            //识别条形码
            Quagga.decodeSingle(config, (result) => {
                console.log("result", result);
                Toast.clear()

                if (!result) {
                    Toast("识别失败，请重新上传图片或手动输入！")
                    // this.$emit("getBarCcode", { identifying: this.identifying, code: "" })
                    return false;
                }
                //识别结果
                if (result.codeResult && result.codeResult.code) {
                    console.log("result.codeResult.code", result.codeResult.code);
                    this.$emit("getBarCcode", { identifying: this.identifying, code: result.codeResult.code })
                } else {
                    Toast("识别失败，请重新上传图片或手动输入！")
                    // this.$emit("getBarCcode", { identifying: this.identifying, code: "" })
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.product-item {
    // width: 345px;
    padding: 15px;
    margin: 10px 0;
    box-sizing: border-box;
    border-radius: 12px;

    .product-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0px;

        .logo {
            width: 22px;
            height: 22px;
            margin-right: 10px;
        }

        .product-name {
            flex: 1;
            font-weight: 600;
            font-size: 18px;
            color: #333333;
        }
    }

    .van-field {
        font-size: 16px;
    }

    .sn-box {
        .van-field {
            border: 1px solid #D32537;
            border-radius: 6px;
        }
    }

    ::v-deep .van-field__control::-webkit-input-placeholder {
        color: #9b9da9;
        font-size: 14px;
    }

    .agreement {
        display: flex;
        align-items: center;
        // justify-content: center;
        padding-left: 15px;
        margin-top: 10px;
        font-size: 12px;
        color: #4F87FF;

        span {
            margin-left: 5px;
        }
    }
}
</style>
